import addMasterInfo from "./add_master_info";
import createInvestTransArrays from "./create_invest_trans_arrays";

export const combineInvestmentTrans = (transactionArr, currentPriceArr, investMasterArr, beginHistoryTransNbr) => {
  transactionArr = JSON.parse(JSON.stringify(transactionArr));
    
    const transactionArrays = createInvestTransArrays(transactionArr, currentPriceArr, beginHistoryTransNbr);
    const updatedTransactionArr = transactionArrays.openTransactions;
    const historyTranArr = transactionArrays.history;
    const buyTransArr = transactionArrays.activeShares;
   
    //  step3 --->  add investmentMaster info to the buyTransArr & historyArr
    let totalBuyArr = addMasterInfo(buyTransArr, investMasterArr)
    let historyArr = addMasterInfo(historyTranArr, investMasterArr);
        
    const returnObj = {summaryBuyArr: totalBuyArr, historyArr: historyArr,
            updatedTransactionArr: updatedTransactionArr};
              
    return returnObj;
   
}

export default combineInvestmentTrans;
